require("./Outline.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Courses/components/Outline.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "col text-ellipsis justify-content-center"
      },
    marko_attrs1 = {
        "class": "font-"
      },
    marko_attrs2 = {
        "class": "position-absolute d-block p-50 move-handle cursor-move",
        style: "left:5px",
        title: "Move"
      },
    marko_attrs3 = {
        "class": "btn-actions col-4 justify-content-center text-right"
      },
    marko_attrs4 = {
        "class": "px-50 cursor-pointer",
        title: "Edit"
      },
    marko_attrs5 = {
        "class": "px-50 cursor-pointer",
        title: "Delete"
      };

const Types = {
  RTXT: 'book-open',
  FLIP: 'carousel',
  MVID: 'slideshow',
  MIVI: 'chalkboard',
  SMLT: 'pyramid',
  LIVE: 'camera-home',
  ASSM: 'question-mark',
  ASSG: 'calendar-check',
  BOOK: 'book',
  XDOC: 'file',
  ESHL: 'link-external'
};

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": "position-relative nav-item sortable-item rounded pl-4 py-25",
      "data-index": input.index
    }, "0", component);

  Row_tag({
      class: "m-0 d-flex align-items-center",
      renderBody: function(out) {
        if (input.editable) {
          out.be("span", marko_attrs2, "2", component, null, 0, {
              onclick: __component.d("click", "onAction", false, [
                  "move"
                ])
            });

          Bx_tag({
              type: "dots-vertical-rounded",
              class: "font-medium-5 p-0 text-muted",
              style: "width:5px"
            }, out, __component, "3");

          Bx_tag({
              type: "dots-vertical-rounded",
              class: "font-medium-5 p-0 text-muted",
              style: "width:5px;"
            }, out, __component, "4");

          out.ee();
        }

        out.be("div", marko_attrs0, "5", component);

        Bx_tag({
            type: Types[input.type] || "file",
            class: ("font-medium-3 border " + ([
                "ASSM",
                "ASSG"
              ].includes(input.type) ? "brown text-white" : "")) + " rounded-circle p-75 mr-2"
          }, out, __component, "6");

        out.e("span", marko_attrs1, "7", component, 1)
          .t(input.title, component);

        out.ee();

        if (input.editable) {
          out.be("div", marko_attrs3, "8", component);

          out.be("span", marko_attrs4, "9", component, null, 0, {
              onclick: __component.d("click", () => component.emit( 'edit', input.reference ), false)
            });

          Bx_tag({
              type: "pencil",
              class: "font-medium-4"
            }, out, __component, "10");

          out.ee();

          out.be("span", marko_attrs5, "11", component, null, 0, {
              onclick: __component.d("click", () => component.emit( 'delete', input.reference ), false)
            });

          Bx_tag({
              type: "trash",
              class: "font-medium-4"
            }, out, __component, "12");

          out.ee();

          out.be("span", {
              "class": "px-50 cursor-pointer",
              title: "Make it " + (input.mandatory ? "Optional" : "Mandatory")
            }, "13", component, null, 0, {
              onclick: __component.d("click", () => component.emit( 'mandatory', { mandatory: !input.mandatory } ), false)
            });

          Bx_tag({
              type: input.mandatory ? "lock-alt" : "lock-open-alt",
              bxs: input.mandatory,
              class: "font-medium-4"
            }, out, __component, "14");

          out.ee();

          out.ee();
        }
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
